var _a, _b;
export var TIERS = {
    SEMISKILLED: 'Semi-skilled',
    TRADE: 'Trades/Technical',
    MID: 'Middle-Tier Professional',
    UPPER: 'Upper-Tier Professional',
    TOP: 'Top-Tier Professional',
    ENTREPRENEURSHIP: 'Entrepreneurship',
};
export var TRACK_CODE_TO_NAME = {
    'semi-skilled': TIERS.SEMISKILLED,
    trades: TIERS.TRADE,
    'middle-tier': TIERS.MID,
    'upper-tier': TIERS.UPPER,
    'top-tier': TIERS.TOP,
    entrepreneurship: TIERS.ENTREPRENEURSHIP,
};
export var TIER_TO_TRACK_CODE = (_a = {},
    _a[TIERS.SEMISKILLED] = 'semi-skilled',
    _a[TIERS.TRADE] = 'trades',
    _a[TIERS.MID] = 'middle-tier',
    _a[TIERS.UPPER] = 'upper-tier',
    _a[TIERS.TOP] = 'top-tier',
    _a[TIERS.ENTREPRENEURSHIP] = 'entrepreneurship',
    _a);
export var TIER_TO_CAREER_TRACK_NAME = (_b = {},
    _b[TIERS.SEMISKILLED] = 'Semi-skilled',
    _b[TIERS.TRADE] = 'Trades/Technical',
    _b[TIERS.MID] = 'Middle-Tier',
    _b[TIERS.UPPER] = 'Upper-Tier',
    _b[TIERS.TOP] = 'Top-Tier',
    _b[TIERS.ENTREPRENEURSHIP] = 'Entrepreneurship',
    _b);
export var AI_IMPACT_AUTOMATION_RISK = {
    Level_1: 'Unlikely',
    Level_2: 'Partial',
    Level_3: 'Significant',
    Level_4: 'High',
};
export var AI_IMPACT_INTEGRATION_INTENSITY = {
    Level_1: 'Minimal',
    Level_2: 'Supportive',
    Level_3: 'Embedded',
    Level_4: 'Central',
};
export var AI_IMPACT_ROLE_REINVENTION_NEED = {
    Level_1: 'Stable',
    Level_2: 'Adapting',
    Level_3: 'Reconfiguring',
    Level_4: 'Transforming',
};
export var AI_IMPACT_LEVERAGE_UPSIDE = {
    Level_1: 'Low',
    Level_2: 'Helpful',
    Level_3: 'Differentiating',
    Level_4: 'Transformative',
};
export var AI_IMPACT_HUMAN_DIFFERENTIATOR_INDEX = {
    Level_1: 'Replaceable',
    Level_2: 'Useful',
    Level_3: 'Enhancing',
    Level_4: 'Essential',
};
export var mapCareerPathResponseToCareerPath = function (career_path) {
    return {
        id: career_path.id,
        career_category_id: career_path.career_category_id,
        career_category: career_path.career_category,
        name: career_path.name,
        description: career_path.description,
        insight: career_path.insight,
        early_career_hires_per_year: {
            skilled_technical: career_path.early_career_hires_per_year_skilled_technical,
            professional: career_path.early_career_hires_per_year_professional,
        },
        growth: career_path.growth,
        ai_disruption: career_path.ai_disruption,
        career_track_distribution: {
            SEMISKILLED: career_path.career_track_distribution_semi_skilled,
            TRADE: career_path.career_track_distribution_trade,
            MID: career_path.career_track_distribution_mid,
            UPPER: career_path.career_track_distribution_upper,
            TOP: career_path.career_track_distribution_top,
        },
        askLubavButtonResponse: career_path.askLubavButtonResponse,
        media_url: career_path.media_url,
        caregiver_flexibility: {
            caregiver_flexibility_score: career_path.caregiver_flexibility_score,
            caregiver_flexibility_part_time_flexible_scheduling: career_path.caregiver_flexibility_part_time_flexible_scheduling,
            caregiver_flexibility_ease_of_reentry_after_gap: career_path.caregiver_flexibility_ease_of_reentry_after_gap,
            caregiver_flexibility_licensure_credential_stability: career_path.caregiver_flexibility_licensure_credential_stability,
            caregiver_flexibility_cultural_support_for_caregivers: career_path.caregiver_flexibility_cultural_support_for_caregivers,
            caregiver_flexibility_skill_half_life_change_velocity: career_path.caregiver_flexibility_skill_half_life_change_velocity,
            caregiver_flexibility_remote_location_flexibility: career_path.caregiver_flexibility_remote_location_flexibility,
            caregiver_flexibility_career_progression_flexibility: career_path.caregiver_flexibility_career_progression_flexibility,
            caregiver_flexibility_synthesis: career_path.caregiver_flexibility_synthesis,
        },
        ai_impact: {
            ai_impact_automation_risk: career_path.ai_impact_automation_risk,
            ai_impact_integration_intensity: career_path.ai_impact_integration_intensity,
            ai_impact_role_reinvention_need: career_path.ai_impact_role_reinvention_need,
            ai_impact_leverage_upside: career_path.ai_impact_leverage_upside,
            ai_impact_human_differentiator_index: career_path.ai_impact_human_differentiator_index,
            ai_impact_five_year_impact_summary: career_path.ai_impact_five_year_impact_summary,
        },
    };
};
